(function imageZoom(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Modules = global.NewHomeSource.Modules || {};

  if (!global.NewHomeSource.Modules.ImageHandler) {
    return;
  }

  const previousImageZoom = global.NewHomeSource.Modules.ImageZoom;

  const scaleFactor = 0.5;
  const maxZoomLevel = 4;
  const zoomOutClass = 'player__zoomout-canvas';
  let onTouchEndEvent = null;
  let onTouchMoveEvent = null;
  let onTouchStartEvent = null;
  let onMouseWheelEvent = null;
  let onMouseLeaveEvent = null;

  /**
  * @private
  * clear: clears the touchNow and touchStart properties.
  */
  function clear() {
    if (this.config.touchNow) {
      this.config.touchNow.x = null;
      this.config.touchNow.y = null;
    }

    this.config.touchStart.x = null;
    this.config.touchStart.y = null;
    this.startObject = null;
  }

  function constrain() {
    const imageHeight = this.picture.height * this.ratio * this.config.zoomLevel;
    const imageWidth = this.picture.width * this.ratio * this.config.zoomLevel;
    const canvasHeight = this.canvas.height - imageHeight;
    const canvasWidth = this.canvas.width - imageWidth;

    this.bounds.left = canvasWidth > 0 ? 0 : canvasWidth;
    this.bounds.right = canvasWidth < 0 ? 0 : canvasWidth;
    this.bounds.top = canvasHeight > 0 ? 0 : canvasHeight;
    this.bounds.bottom = canvasHeight < 0 ? 0 : canvasHeight;

    if (this.dx < this.bounds.left) {
      this.dx = this.bounds.left;
    }

    if (this.dx > this.bounds.right) {
      this.dx = this.bounds.right;
    }

    if (this.dy < this.bounds.top) {
      this.dy = this.bounds.top;
    }

    if (this.dy > this.bounds.bottom) {
      this.dy = this.bounds.bottom;
    }

    if (this.config.zoomLevel === 1) {
      this.dx = (this.config.canvasWidth - this.picture.width * this.ratio * this.config.zoomLevel) / 2;
      this.dy = (this.config.canvasHeight - this.picture.height * this.ratio * this.config.zoomLevel) / 2;
    }
  }

  /**
  * @private
  * isScrolling: returns true if a touchStart event has been triggered, otherwise false.
  */
  function isScrolling() {
    if (!this.startObject) {
      return false;
    }

    return this.startObject.x || this.startObject.x === 0 || this.startObject.y || this.startObject.y === 0;
  }

  /**
  * @private
  * movement: returns the clientX and clientY coordinates of the mouse or touch event.
  *
  * @param {event} event with the information of the mouse or touch event.
  */
  function movement(event) {
    if (event.changedTouches) {
      return {
        x: event.changedTouches[0].clientX,
        y: event.changedTouches[0].clientY,
      };
    }

    return {
      x: event.clientX,
      y: event.clientY,
    };
  }

  /**
  * @private
  * onTouchEnd: handler of mouse up and touch end events.
  *
  * @param {event} event with the information of the mouse or touch event.
  */
  function onTouchEnd(event) {
    event.preventDefault();

    if (!this.startObject || !this.startObject.x || !this.startObject.y) {
      return;
    }

    const move = movement(event);
    const totalMovementInX = Math.abs(move.x - this.startObject.x);
    const totalMovementInY = Math.abs(move.y - this.startObject.y);
    const timeElapsed = new Date() - this.startObject.time;
    const isClick = !(totalMovementInX > 10 || totalMovementInY > 10 || timeElapsed > 1000);

    if (isClick) {
      this.zoom(!event.shiftKey, event.offsetX, event.offsetY);
    }

    clear.call(this);
  }

  /**
  * @private
  * onTouchMove: handler of mouse and touch move events.
  *
  * @param {event} event with the information of the mouse or touch event.
  */
  function onTouchMove(event) {
    event.preventDefault();

    if (!this.isScrolling() || this.config.zoomLevel === 1) {
      return;
    }

    const moveX = this.config.touchNow.x - this.config.touchStart.x;
    const moveY = this.config.touchNow.y - this.config.touchStart.y;

    this.pan(moveX, moveY);
    this.config.touchStart = this.config.touchNow;
    this.config.touchNow = movement(event);
  }

  /**
  * @private
  * onTouchStart: handler of mouse down and touch start events.
  *
  * @param {event} event with the information of the mouse or touch event.
  */
  function onTouchStart(event) {
    event.preventDefault();

    const move = movement(event);

    this.config.touchStart = move;
    this.config.touchNow = move;
    this.startObject = {
      x: move.x,
      y: move.y,
      time: new Date(),
    };

    return null;
  }

  /**
   * @private
   * onWheel: handler of the mouse wheel event.
   *
   * @param {event} event with the scroll wheel information/
   */
  function onWheel(event) {
    const direction = event.deltaY * -1;
    const eventDetail = event.detail ? -event.detail : 0;
    const delta = event.wheelDelta ? event.wheelDelta / 40 : eventDetail;
    const move = movement(event);
    let isZoomIn = false;

    if (!delta) {
      return;
    }

    if (Math.abs(direction) < 1) {
      return;
    }

    if (direction > 0) {
      isZoomIn = true;
    }

    this.zoom(isZoomIn, move.x, move.y);
  }

  /**
  * @private
  * redraw: draws the picture from scratch in the canvas element.
  */
  function redraw() {
    const dHeight = this.picture.height * this.ratio * this.config.zoomLevel;
    const dWidth = this.picture.width * this.ratio * this.config.zoomLevel;

    constrain.call(this);
    this.drawingContext.save();
    this.drawingContext.clearRect(0, 0, this.config.canvasWidth, this.config.canvasHeight);
    this.drawingContext.restore();
    this.drawingContext.drawImage(
      this.picture,
      0,
      0,
      this.picture.width,
      this.picture.height,
      this.dx,
      this.dy,
      dWidth,
      dHeight
    );
  }

  /**
  * @private
  * onImageLoaded do the maths that needs to know the image dimensions, and attach the events.
  */
  function onImageLoaded() {
    this.canvas.removeEventListener('mousedown', onTouchStartEvent, false);
    this.canvas.removeEventListener('mouseleave', onMouseLeaveEvent, false);
    this.canvas.removeEventListener('mousemove', onTouchMoveEvent, false);
    this.canvas.removeEventListener('mouseup', onTouchEndEvent, false);
    this.canvas.removeEventListener('wheel', onMouseWheelEvent, false);
    this.canvas.removeEventListener('touchstart', onTouchStartEvent, false);
    this.canvas.removeEventListener('touchmove', onTouchMoveEvent, false);
    this.canvas.removeEventListener('touchend', onTouchEndEvent, false);

    onTouchStartEvent = onTouchStart.bind(this);
    onMouseLeaveEvent = clear.bind(this);
    onTouchMoveEvent = onTouchMove.bind(this);
    onTouchEndEvent = onTouchEnd.bind(this);
    onMouseWheelEvent = onWheel.bind(this);

    this.canvas.addEventListener('mousedown', onTouchStartEvent, false);
    this.canvas.addEventListener('mouseleave', onMouseLeaveEvent, false);
    this.canvas.addEventListener('mousemove', onTouchMoveEvent, false);
    this.canvas.addEventListener('mouseup', onTouchEndEvent, false);
    this.canvas.addEventListener('wheel', onMouseWheelEvent, false);

    this.canvas.addEventListener('touchstart', onTouchStartEvent, false);
    this.canvas.addEventListener('touchmove', onTouchMoveEvent, false);
    this.canvas.addEventListener('touchend', onTouchEndEvent, false);

    this.ratio = Math.min(this.config.canvasWidth / this.picture.width, this.config.canvasHeight / this.picture.height);
    this.config.touchStart = {};
    requestAnimationFrame(redraw.bind(this));
  }

  /**
  * @constructs ImageZoom
  *
  * @param {HTMLCanvasElement} canvas element where the picture is going to be displayed.
  * @param {string} picture URL of the picture to be added to the canvas element.
  */
  function ImageZoom(canvas, picture) {
    const image = new Image();

    this.picture = image;
    this.canvas = canvas;
    this.canvas.imageSmoothingEnabled = true;
    this.bounds = {};
    this.bounds.top = NaN;
    this.bounds.left = NaN;
    this.bounds.right = NaN;
    this.bounds.bottom = NaN;
    this.config = {};
    this.config.canvasWidth = canvas.width;
    this.config.canvasHeight = canvas.height;
    this.config.zoomLevel = 1;
    this.drawingContext = canvas.getContext('2d');

    image.onload = onImageLoaded.bind(this);
    image.src = global.NewHomeSource.Modules.ImageHandler.addJpgParameter(picture);
  }

  /**
  * @public
  * isScrolling: returns true if a touchStart event has been triggered, otherwise false.
  */
  ImageZoom.prototype.isScrolling = isScrolling;

  /**
  * @public
  * pan: moves the image to the given position.
  *
  * @param {number} x coordinate in the X axis to move the image.
  * @param {number} y coordinate in the Y axis to move the image.
  */
  ImageZoom.prototype.pan = function pan(x, y) {
    this.dx += x;
    this.dy += y;
    requestAnimationFrame(redraw.bind(this));
  };

  /**
  * @public
  * redraw: draws the picture from scratch in the canvas element.
  */
  ImageZoom.prototype.redraw = redraw;

  /**
  * @public
  * resize: sets a new width and height to the canvas element.
  *
  * @param {number} width new value for the X axis.
  * @param {number} height new value for the Y axis.
  */
  ImageZoom.prototype.resize = function resize(width, height) {
    this.canvas.width = width * 1;
    this.canvas.height = height * 1;
    this.config.canvasHeight = this.canvas.height;
    this.config.canvasWidth = this.canvas.width;
    this.dx = (this.config.canvasWidth - this.picture.width * this.ratio * this.config.zoomLevel) / 2;
    this.dy = (this.config.canvasHeight - this.picture.height * this.ratio * this.config.zoomLevel) / 2;
    this.ratio = Math.min(this.config.canvasWidth / this.picture.width, this.config.canvasHeight / this.picture.height);
    requestAnimationFrame(redraw.bind(this));
  };

  /**
  * @public
  * zoom: increases or decreases the size of the image.
  *
  * @param {boolean} isZoomIn true if the intention is to increase the size of the image, otherwise false.
  * @param {number} x translation in the X axis after the zoom.
  * @param {number} y translation in the X axis after the zoom.
  */
  ImageZoom.prototype.zoom = function zoom(isZoomIn, x, y) {
    let direction;

    if (isZoomIn) {
      direction = 1;
    } else {
      direction = -1;
    }

    this.config.zoomLevel += direction * scaleFactor;

    if (this.config.zoomLevel > maxZoomLevel) {
      this.config.zoomLevel = maxZoomLevel;
      this.canvas.classList.add(zoomOutClass);
    } else {
      this.canvas.classList.remove(zoomOutClass);
    }

    if (this.config.zoomLevel < 1) {
      this.config.zoomLevel = 1;
      return;
    }

    const adjustedClickX = x * this.config.zoomLevel;
    const adjustedClickY = y * this.config.zoomLevel;
    const realCanvasWidth = this.canvas.width * this.config.zoomLevel;
    const realCanvasHeight = this.canvas.height * this.config.zoomLevel;
    const differenceX = this.canvas.width - realCanvasWidth;
    const differenceY = this.canvas.height - realCanvasHeight;
    const positionX = realCanvasWidth / adjustedClickX;
    const positionY = realCanvasHeight / adjustedClickY;
    let dx = differenceX / positionX;
    let dy = differenceY / positionY;

    if (this.dx > 0) {
      dx = this.dx / this.config.zoomLevel;
    }

    if (this.dy > 0) {
      dy = this.dy / this.config.zoomLevel;
    }

    if (!x || !y) {
      dx = (this.config.canvasWidth - this.picture.width * this.ratio * this.config.zoomLevel) / 2;
      dy = (this.config.canvasHeight - this.picture.height * this.ratio * this.config.zoomLevel) / 2;
    }

    this.dx = dx;
    this.dy = dy;
    requestAnimationFrame(redraw.bind(this));
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.ImageZoom to the previous script.
   */
  ImageZoom.noConflict = function noConflict() {
    global.NewHomeSource.Modules.ImageZoom = previousImageZoom;
    return ImageZoom;
  };

  global.NewHomeSource.Modules.ImageZoom = ImageZoom;
}(window));
